module.exports = __webpack_public_path__ + "fd197dd1484669359eaa304d90dcfbfc.png";